(function() {

  angular
	.module('meanApp')
	.controller('featuresCtrl', featuresCtrl);

  featuresCtrl.$inject = ['$location', 'featuresManager', 'Feature', '$rootScope', 'alert', '$scope', 'confirmationModal'];
  function featuresCtrl($location, featuresManager, Feature, $rootScope, alert, $scope, confirmationModal) {
	var vm = this;
	//console.log('the current user is ', $rootScope.currentUser);
	vm.features = {};

	$rootScope.$watch('currentUser', function () {
		if ($rootScope.currentUser) {
			if($rootScope.currentUser.role === 'admin'){
				loadFeatures();
			}
			else {
				$location.path('/');
			}
		}
	}, function(err) {
		console.log(err);
	});

	var loadFeatures = function() {
		featuresManager.getAll()
		.then(function(result) {
			vm.features = result.collection;
		}, function(err) {
			console.log('error loafing all features');
		});
	};

	vm.confirmationQuestion = 'Voulez vous vraiment supprimer cette propriété de recette ?';
	vm.onConfirmationModalClick = function() {
		featuresManager.delete($scope.featureIDToDelete)
		.then(function() {
			this.$close();
	  		alert.push('success', 'Cette propriété a été supprimée définitivement de la base de données');
	  	}.bind($scope), function() {
	  		this.$close();
	  		alert.push('danger', "Cet propriété n'a pas pu être supprimée");
	  	}.bind($scope));
	};
	
	vm.removeFeature = function(id) {
		$scope.featureIDToDelete = id;
		$scope.modalInstance = confirmationModal.open($scope, 'featuresCtrl');
	};

	vm.onFeatureSubmit = function() {
		if (typeof vm.id !== 'undefined' && vm.name) {
			var newFeature = new Feature({
				easyID: vm.id,
				name: vm.name
			});
			newFeature.save()
			.then(function (feature) {
				var instanceFeature = featuresManager.set(feature);
				vm.features.push(instanceFeature);
				alert.push('success', 'Nouveau feature ajouté en base de données');
			}, function (error) {
				//TOOD préciser si déja en base de données ou quoi
				alert.push('danger', 'Feature non ajouté en base de données');
			});
		}
	};

  }

})();